import React from 'react';
import { Copy, Check, Settings } from 'lucide-react';
import { Button } from '../../ui/Button';
import { UseShareDatasetReturn } from './types';
import { ShareToggle } from './ShareToggle';
import { SocialShareButtons } from './SocialShareButtons';
import { ShareSettingsPanel } from './ShareSettingsPanel';

interface DesktopSharePopoverProps {
  share: UseShareDatasetReturn;
  tableName: string;
  position: { top: number; right: number };
  popoverRef: React.RefObject<HTMLDivElement>;
}

export const DesktopSharePopover: React.FC<DesktopSharePopoverProps> = ({ share, tableName, position, popoverRef }) => (
  <div ref={popoverRef} style={{ top: position.top, right: position.right }} className="fixed w-80 bg-white rounded-xl shadow-lg border border-neutral-200 z-[200] overflow-hidden animate-popoverSlideIn">
    <div className="p-3 px-4">
      <ShareToggle isPublic={share.isPublic} isToggling={share.isToggling} onToggle={share.handleTogglePublic} size="sm" />
      <div className={`overflow-hidden transition-all duration-250 ${share.isPublic && share.activeShare ? 'max-h-[300px] opacity-100 mt-3' : 'max-h-0 opacity-0 mt-0'}`}>
        <Button onClick={share.handleCopyShareUrl} variant="primary" fullWidth size="sm" className={`mb-3 !bg-neutral-900 hover:!bg-neutral-800 ${share.copiedToken ? '!bg-neutral-700' : ''}`} leftIcon={share.copiedToken ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}>
          {share.copiedToken ? 'Copied to clipboard' : 'Copy link'}
        </Button>
        <div className="flex items-center justify-between">
          <SocialShareButtons shareUrl={share.shareUrl} title={share.shareSettings.title || tableName} size="sm" />
          <button type="button" onClick={() => share.setShowAdvancedOptions(!share.showAdvancedOptions)} className={`flex items-center justify-center w-8 h-8 rounded-lg transition-colors ${share.showAdvancedOptions ? 'bg-neutral-200' : 'bg-neutral-100 hover:bg-neutral-200'}`} title="Settings">
            <Settings className="w-3.5 h-3.5 text-neutral-500" />
          </button>
        </div>
        {share.showAdvancedOptions && (
          <div className="mt-2.5">
            <ShareSettingsPanel settings={share.shareSettings} onSettingsChange={share.setShareSettings} onSave={share.handleSaveSettings} onDelete={share.handleDeleteShare} isSaving={share.isSaving} compact />
          </div>
        )}
      </div>
    </div>
  </div>
);
